import axios from "axios";

interface IHistoryData {
  entityId: number;
  id: number;
  model: {
    [changeName: string]: {
      value: string;
      overridenValue: string;
    };
  };
  modifiedById: number;
  modifiedDateTime: string;
}

export default {
  //                            Organizations
  getOrganizationsWithBuildings(params) {
    return axios.post("/OrgStructure/OrganizationsWithBuildings", {
      ...params,
      page: params.page ?? 1,
      count: params.count ?? 10,
    });
  },

  getOrganizationHistory(id) {
    return axios.get(`Orgstructure/OrganizationMain/${id}/History`);
  },
  insertOrg(data) {
    return axios.post("Orgstructure/OrganizationMain", data);
  },
  updateOrg(data) {
    return axios.put(`Orgstructure/OrganizationMain/${data.id}`, data);
  },
  deleteOrg(id) {
    return axios.delete(`Orgstructure/OrganizationMain/${id}`);
  },
  getOrgHistory(id) {
    return axios.get<IHistoryData[]>(
      `Orgstructure/OrganizationMain/${id}/History`,
    );
  },

  //                              Building
  getBuildingsByOrg(orgId) {
    return axios.get(`Orgstructure/Buildings`, { params: { orgId } });
  },
  deleteBuilding(id) {
    return axios.delete(`Orgstructure/BuildingMain/${id}`);
  },
  getBuilding(id) {
    return axios.get(`Orgstructure/BuildingMain/${id}`);
  },
  insertBuilding(data) {
    return axios.post(`Orgstructure/BuildingMain`, data);
  },
  updateBuilding(data) {
    return axios.put(`Orgstructure/BuildingMain/${data.id}`, data);
  },
  updatefiles(data){
    return axios.post(`Orgstructure/ImportOrganizationMainListFromFile`, data);
  }
};
